module.exports = __webpack_public_path__ + "media/svg-new/avatar-10 1-fcd62512.svg";